import { LuCircle, LuCircleCheck } from 'react-icons/lu';
import { useStrings } from '../../tenant/TenantProvider';

export const PASSWORD_RULES = [
  { id: 'length', test: (value) => value.length >= 8 },
  { id: 'lower', test: (value) => /[a-z]/.test(value) },
  { id: 'upper', test: (value) => /[A-Z]/.test(value) },
  { id: 'number', test: (value) => /\d/.test(value) },
  { id: 'symbol', test: (value) => /[@$!%*?&]/.test(value) },
];

export const isStrongPassword = (value) =>
  PASSWORD_RULES.every((rule) => rule.test(value)) && /^[A-Za-z\d@$!%*?&]+$/.test(value);

export function PasswordRules({ value, id }) {
  const t = useStrings();
  return (
    <ul className="password-rules" id={id}>
      {PASSWORD_RULES.map((rule) => {
        const met = rule.test(value);
        const Icon = met ? LuCircleCheck : LuCircle;
        return (
          <li key={rule.id} className={met ? 'is-met' : undefined}>
            <Icon aria-hidden="true" />
            {t(`auth.rules.${rule.id}`)}
          </li>
        );
      })}
    </ul>
  );
}
